export const en = {
  header: {
    status: "AVAILABLE",
    name: "LUAN LIMA",
    title: "SOFTWARE ENGINEER // WEBRTC, LIVEKIT & NESTJS SPECIALIST",
    timeLabel: "BRT (UTC-3):"
  },
  hero: {
    badge: "SOFTWARE ENGINEER",
    titleLine1: "ENGINEERING SCALABLE",
    titleHighlight: "REAL-TIME SYSTEMS",
    titleLine2: "& HIGH-PERFORMANCE APIS.",
    description: "Software Engineer with over 12 years of experience. NestJS & Node.js Specialist, WebRTC & LiveKit expert, and Bun & Elysia.js advocate building enterprise scalable high-concurrency systems.",
    btnLinkedin: "LINKEDIN PROFILE",
    btnGithub: "GITHUB REPOSITORIES"
  },
  specSheet: {
    header: "// TECHNICAL SPEC SHEET",
    name: "LUAN LIMA",
    mainRoleLabel: "ROLE:",
    mainRoleVal: "Software Engineer",
    experienceLabel: "EXPERIENCE:",
    experienceVal: "12+ Years Experience",
    focusLabel: "SPECIALTY:",
    focusVal: "NestJS, Node.js, WebRTC, LiveKit, Bun & Elysia",
    languagesLabel: "LANGUAGES:",
    languagesVal: "Portuguese, English",
    workModelLabel: "WORK MODEL:",
    workModelVal: "Remote / Contract / Consulting",
    locationLabel: "LOCATION:",
    locationVal: "Brazil (UTC-3)",
    summary: "Software Engineer with over 12 years of experience creating real-time systems, ultra-low latency APIs, and scalable products within the JavaScript/TypeScript ecosystem."
  },
  marquee: {
    headline: "// CONTINUOUS STACK LINE (HOVER TO PAUSE / CLICK TO SELECT)",
    badge: "FULLSTACK JS STACK"
  },
  matrix: {
    badge: "// COMPETENCY MATRIX",
    title: "Tech Stack & Engineering",
    categoryAll: "ALL",
    categories: {
      "Backend & Runtimes": "Backend & Runtimes",
      "Realtime & Architecture": "Realtime & Architecture",
      "Frontend & Mobile": "Frontend & Mobile",
      "Databases & ORMs": "Databases & ORMs"
    }
  },
  inspector: {
    badge: "TECHNOLOGY INSPECTOR",
    header: "// SELECTED TECHNOLOGY",
    categoryLabel: "Category:",
    expLevelLabel: "PRACTICE LEVEL:",
    practicalAppLabel: "PRACTICAL APPLICATION:",
    techNoteHeader: "// TECHNICAL NOTE",
    techNoteText: "Integrated into the high-performance JavaScript/TypeScript ecosystem to ensure development speed, type consistency, and scale.",
    statusActive: "STATUS: ACTIVE STACK"
  },
  projects: {
    badge: "// PROJECTS & EXPERIENCE",
    title: "Selected Projects",
    techFocusLabel: "TECHNICAL FOCUS:",
    items: {
      "01": {
        title: "Executive Jiu-Jitsu — Mobile App (iOS & Android)",
        category: "MOBILE ENGINEERING & NATIVE EXPO ARCHITECTURE",
        description: "Enterprise mobile application engineering built with Expo SDK 57 and React Native. UI crafted with native system components (Apple Liquid Glass and SF Symbols), Expo Router navigation architecture, tactile feedback via expo-haptics, offline-first synchronization, and automated multi-platform compilation pipeline via Expo EAS Build.",
        metrics: "Expo SDK 57 • Native UI (Liquid Glass) • EAS Build"
      },
      "02": {
        title: "WebRTC & SFU Realtime Infrastructure Platform",
        category: "WEBRTC, LIVEKIT & HIGH-CONCURRENCY REALTIME",
        description: "Infrastructure engineering for high-concurrency real-time audio, video, and data streaming. Implementation of WebRTC SFU architecture using LiveKit and WebSockets to ensure ultra-low latency communication at scale.",
        metrics: "Ultra-Low Latency & WebRTC SFU Architecture"
      },
      "03": {
        title: "Monorepos Architecture & APIs in Bun & Elysia.js",
        category: "HIGH-SPEED RUNTIMES & MONOREPO ARCHITECTURE",
        description: "Building scalable microservices ecosystems and monorepos using Bun, Workspaces, and Elysia.js with Drizzle ORM. Optimization of build times, bundling, and sub-50ms HTTP responses.",
        metrics: "High-Speed Bundling & Sub-50ms API Latency"
      },
      "04": {
        title: "Enterprise Systems in NestJS & Clean Architecture",
        category: "ENTERPRISE NODE.JS, DDD & CLEAN ARCHITECTURE",
        description: "Development and structuring of scalable enterprise architecture in NestJS and Node.js. Strict application of Domain-Driven Design (DDD), Test-Driven Development (TDD), and integration with reactive UIs in React and Angular.",
        metrics: "Enterprise DDD, TDD & 100% Type-Safe Contracts"
      }
    }
  },
  principles: {
    badge: "// TECHNICAL PILLARS",
    title: "Engineering Principles",
    p1Code: "01 // REALTIME & PERFORMANCE",
    p1Title: "WebRTC & Fast Runtimes",
    p1Desc: "Leveraging WebRTC, WebSockets, and runtimes like Bun and Node.js optimized for low-latency real-time communication.",
    p2Code: "02 // DOMAIN-DRIVEN DESIGN (DDD)",
    p2Title: "Domain Modeling & Clean Arch",
    p2Desc: "Building domain-centric software with DDD, isolating core business logic within Bounded Contexts and Clean Architecture.",
    p3Code: "03 // TEST-DRIVEN DEVELOPMENT (TDD)",
    p3Title: "Quality & Automated Testing",
    p3Desc: "Test-driven development (TDD) with unit and integration tests using Bun Test & Jest for maximum coverage and safe refactoring.",
    p4Code: "04 // CLEAN CODE & BEST PRACTICES",
    p4Title: "Clean Code & SOLID Principles",
    p4Desc: "Writing self-documenting, cohesive, and readable code while enforcing SOLID principles and design patterns for continuous maintainability."
  },
  contact: {
    badge: "LUAN_LIMA // CONTACT",
    headline: "Let's talk about new projects or opportunities.",
    subtitle: "Open for Software Engineer roles, JavaScript/WebRTC system architecture, and technical consulting.",
    copyBtnDefault: "COPY EMAIL ADDRESS",
    copyBtnSuccess: "EMAIL COPIED TO CLIPBOARD",
    copyright: "© 2026 LUAN LIMA. ALL RIGHTS RESERVED."
  },
  stacks: {
    "bun-elysia": {
      category: "Backend & Runtimes",
      experience: "High-Performance & High-Speed",
      highlight: "Ultra-fast Bun Runtime, Elysia.js HTTP Server, High-Speed Bundling & Low-Latency APIs"
    },
    "node": {
      category: "Backend & Runtimes",
      experience: "Professional Specialist",
      highlight: "Enterprise Microservices Architecture with NestJS & Node.js, Dependency Injection (DI), Decorators, Modules, Express/Fastify & Resilient RESTful APIs."
    },
    "ts-js": {
      category: "Backend & Runtimes",
      experience: "Ecosystem Core",
      highlight: "Strict Typing, Rigid Contracts, Advanced Asynchrony & Event Loop in JavaScript (ES6+) and TypeScript"
    },
    "webrtc-ws": {
      category: "Realtime & Architecture",
      experience: "Real-Time Specialty",
      highlight: "WebRTC SFU Architecture with LiveKit, P2P transmission, DataChannels, real-time audio/video streaming & high-concurrency WebSockets."
    },
    "api": {
      category: "Realtime & Architecture",
      experience: "System Architecture",
      highlight: "Resilient RESTful APIs, Event-Driven Architecture, WebSockets, Server-Sent Events (SSE) & unified contracts."
    },
    "clean-tdd-ddd": {
      category: "Realtime & Architecture",
      experience: "Engineering Practices",
      highlight: "Domain-Driven Design (DDD), Test-Driven Development (TDD), Clean Architecture, SOLID Principles & Automated Testing"
    },
    "react-vue": {
      category: "Frontend & Mobile",
      experience: "Professional Experience",
      highlight: "Scalable Web Applications in React.js & Vue.js, Modular Components, Hooks & Advanced Reactivity"
    },
    "angular": {
      category: "Frontend & Mobile",
      experience: "Enterprise Architecture",
      highlight: "Reactive Web Development in Angular, Enterprise SPAs, Dependency Injection & RxJS"
    },
    "rn-expo": {
      category: "Frontend & Mobile",
      experience: "Mobile Development",
      highlight: "Cross-Platform Applications in React Native & Expo, EAS Builds & JS Ecosystem Integration"
    },
    "styling": {
      category: "Frontend & Mobile",
      experience: "UI & Design Systems",
      highlight: "Tailwind CSS, Styled Components, Design Tokens, Cyber-Minimalist Responsive UIs & Animations"
    },
    "mysql-postgres": {
      category: "Databases & ORMs",
      experience: "Professional Experience",
      highlight: "MySQL & PostgreSQL Relational Databases, Query Optimization, Indexing & Strict Data Modeling"
    },
    "drizzle-prisma": {
      category: "Databases & ORMs",
      experience: "Professional Experience",
      highlight: "Type-safe SQL Queries, Database Migrations, Drizzle ORM, Prisma & Relational Modeling"
    }
  }
};
